import { render, staticRenderFns } from "./NoticeList.vue?vue&type=template&id=4bd96d1a&scoped=true&"
import script from "./NoticeList.vue?vue&type=script&lang=js&"
export * from "./NoticeList.vue?vue&type=script&lang=js&"
import style0 from "./NoticeList.vue?vue&type=style&index=0&id=4bd96d1a&scoped=true&lang=css&"
import style1 from "./NoticeList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd96d1a",
  null
  
)

export default component.exports